import { useMemo, useState } from "react";

export const useListItemEditor = <TItem, TValues>(
	items: TItem[],
	toValues: (item: TItem) => TValues,
) => {
	const [editingIndex, setEditingIndex] = useState<number | null>(null);

	const editingItem = editingIndex === null ? undefined : items[editingIndex];

	const initialValues = useMemo(
		() => (editingItem ? toValues(editingItem) : undefined),
		[editingItem],
	);

	return {
		editingIndex,
		editingItem,
		isEditing: editingIndex !== null,
		initialValues,
		startEdit: (index: number) => setEditingIndex(index),
		stopEdit: () => setEditingIndex(null),
	};
};
